import {CSSProperties} from "react";
import NumberInputLabel from "./numberInputLabel.element";
import ResetToDefaultButton from "./resetToDefaultButton.element";
import {FieldConstraint} from "../models/attributeManifest.model";

interface DefaultedNumberInputLabelProps {
    title?: string;
    // undefined = not authored: the input shows the default, and nothing is written until it is edited.
    value: number | undefined;
    // What the game uses while the value is not authored; must match the Client's own default.
    defaultValue: number;
    step?: string;
    displayDecimals?: number;
    tooltip?: string;
    style?: CSSProperties;
    field?: string;
    constraint?: FieldConstraint | null;
    onChange(value: number): void;
    // Remove the authored value, so the default applies again.
    onReset(): void;
}

// A number field with a default: NumberInputLabel with the ↺ that marks and restores it.
function DefaultedNumberInputLabel(props: DefaultedNumberInputLabelProps) {
    return (
        <NumberInputLabel title={props.title} tooltip={props.tooltip} field={props.field} constraint={props.constraint}
                          value={props.value ?? props.defaultValue} step={props.step} displayDecimals={props.displayDecimals}
                          style={props.style} onChange={props.onChange}
                          accessory={<ResetToDefaultButton isSet={props.value !== undefined} defaultLabel={String(props.defaultValue)}
                                                           attached onReset={props.onReset}/>}/>
    );
}

export default DefaultedNumberInputLabel;
